import { Injectable } from "@angular/core";
import { catchError, map, Observable, of, shareReplay } from "rxjs";
import { v4 as uuidv4 } from "uuid";
import { PhoneCompany } from "../../services/generated/waba-api/models";
import { CompanyApiService } from "../../services/generated/waba-api/services";
import { SILENT_HTTP_CONTEXT } from "../utils/silent-http.util";

@Injectable({ providedIn: "root" })
export class CompanyPhonesService {
  private phones$?: Observable<PhoneCompany[]>;

  constructor(private companyService: CompanyApiService) {}

  /** Cached company WhatsApp numbers for the current session. */
  list(): Observable<PhoneCompany[]> {
    if (!this.phones$) {
      this.phones$ = this.companyService
        .companyNumbersList(
          {
            "x-api-canal": "web",
            "x-api-requestId": uuidv4(),
          },
          SILENT_HTTP_CONTEXT,
        )
        .pipe(
          map((res) => res.body ?? []),
          catchError(() => of([])),
          shareReplay({ bufferSize: 1, refCount: false }),
        );
    }
    return this.phones$;
  }

  invalidate(): void {
    this.phones$ = undefined;
  }
}
